import ChartTab from "./ChartTab";
import React from "react";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";
import _ from "lodash-es";

const FIXED0 = value => {
  return Number.parseFloat(Number.parseFloat(value).toFixed(0));
};

class ChartBudgetProjectTabPure extends React.Component {
  render() {
    const { data } = this.props;    
    let pivots = ["project", "tiersGroup", "tiers"];
    //  let pivots = [];
    let showColumns = ["project", "tiersGroup", "tiersAsClient", "dateMonthYear", "previousYearRealValueOrBudget", "budget", "realValue", "budgetVariation",  "budgetVariationPourcent"];
   
    if (!!data)
      for (let line of data) {
        // console.log("Line=", line);
        line.dateMonthYear = line.year + "-" + ("0" + line.month).slice(-2);        
        line.budgetVariation = FIXED0(line.realValue - line.amount);

        if (line.amount !== 0)
          line.budgetVariationPourcent = _.round((line.budgetVariation / line.amount) * 100.0, 1);
        else
          line.budgetVariationPourcent = 0.0;
      }
    
    return (
      <ChartTab
        {...this.props}
        data={data}
        defaultPageSize={computeDefaultTableSize(data, "project")}
        pivots={pivots}
        showColumns={showColumns}
        showPagination={false}
        showDetails={false}
        showExtra={true}
      />
    );
  }
}

export default ChartBudgetProjectTabPure;
